export const MAX_INTENTION_LENGTH = 160

export enum IntentionActionTypes {
  SET_WIDGET_INTENTION = 'SET_WIDGET_INTENTION',
}
